import React from 'react';
import {Stack, Box} from '@mui/material';

type TinyHeaderProps = {
  right?: React.ReactNode; // TODO in case we need it
  left?: React.ReactNode; // TODO in case we need it
  middle?: React.ReactNode;
};

export const TinyHeader = (props: TinyHeaderProps) => {
  return (
    <Stack flexDirection="row" sx={{placeContent: 'center'}} gap="8px" mb="10px">
      <Box bgcolor="primary.main" borderRadius="4px" p="3px">
        {props.middle}
      </Box>
    </Stack>
  );
};
